export default "__VITE_ASSET__CQ5iRixZ__"